import React, { ReactNode, ReactElement, FC } from "react";

interface IUnsafeLineClampProps {
  clamp: number;
  children: ReactNode | null;
  style?: React.CSSProperties;
}

interface IDotdotdotProps {
  clamp: number;
  children: ReactNode;
  style?: React.CSSProperties;
}

const Dotdotdot: FC<IDotdotdotProps> = ({ clamp, children, style }): ReactElement => {
  return (
    <UnsafeLineClamp clamp={clamp} style={style}>
      {children}
    </UnsafeLineClamp>
  );
};

function UnsafeLineClamp({ clamp, children, style }: IUnsafeLineClampProps): ReactElement {
  return (
    <span
      css={{
        lineClamp: clamp,
        WebkitLineClamp: clamp,
        WebkitBoxOrient: "vertical",
        display: "-webkit-box",
        overflow: "hidden"
      }}
      style={style}
    >
      {children}
    </span>
  );
}

export default Dotdotdot;
